<template>
  <div>
    <span class="watch-list-item--color" :style="{ backgroundColor: '#' + item.color }"></span>
    <span style="float: left">{{ $filters.shortString(item.name) }}</span>
  </div>
</template>
<script>
export default {
  name: 'watch-list-option',
  props: ['item']
};
</script>
